import { render, staticRenderFns } from "./projectGantt.vue?vue&type=template&id=e24b7252&scoped=true&"
import script from "./projectGantt.vue?vue&type=script&lang=js&"
export * from "./projectGantt.vue?vue&type=script&lang=js&"
import style0 from "./projectGantt.vue?vue&type=style&index=0&id=e24b7252&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24b7252",
  null
  
)

export default component.exports